import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const QRCodeMapComponent = ({ selectedChannel, onInnerFormChange }: any) => (
          <>
 <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Code"
          labelField="Code"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'QRCodeMapping.Code',
              selectedChannel?.QRCodeMapping
            );
          }}
          type="text"
          value={selectedChannel?.QRCodeMapping?.Code}
      />
    </div>
          }
      expandedPanel="QR Code Mapping Info"
      headerTitle="QR Code Mapping Info"
  />
</>
)
export default QRCodeMapComponent;
